import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ErrorState = ({ error, navigate }) => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center py-12">
          <Icon name="AlertCircle" size={64} className="text-error mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-text-primary mb-2">Job Not Found</h2>
          <p className="text-text-secondary mb-6">{error}</p>
          <p className="text-text-secondary mb-6">Redirecting to job search page...</p>
          <div className="flex justify-center space-x-4">
            <Button variant="outline" onClick={() => navigate(-1)}>
              Go Back
            </Button>
            <Button variant="primary" onClick={() => navigate('/job-search')}>
              Browse Jobs
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorState;